import dayjs from 'dayjs';
import { PointeauType } from '../../app.constants';
import { Nommable } from '../nommable.model';
import { UUID } from '../uuid.model';

export class Pointage extends Nommable {
  constructor(
    id: UUID,
    libelle: string,
    public description: string,
    public instant: dayjs.Dayjs | undefined,
    public iteration: number,
    public parcours: boolean,
    public type: PointeauType,
    public idPointeau: UUID
  ) {
    super(id, libelle);
  }

  public static hydrate(obj: Pointage): Pointage {
    return new Pointage(
      obj.id,
      obj.libelle,
      obj.description,
      obj.instant ? dayjs(obj.instant) : undefined,
      obj.iteration,
      obj.parcours,
      obj.type,
      obj.idPointeau
    );
  }
}
